import { useState } from "react";
import { createApiCall } from "../api/api-service";
import { Button, Container, TextField } from "@mui/material";

export default function ExcelProduct() {

    const [url,setUrl ] = useState('')
    const  handleChange = (e) =>{
        setUrl(e.target.value)
    }
    const submitEve = async () =>{
        const response = await createApiCall( "BLOB","inventory/download_vairant_excel",{'product_url':url})
        console.log(response)
        const uri = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = uri
        
        link.setAttribute('download',url.split("/")[4]+".xlsx")
        document.body.appendChild(link)
        link.click()
        link.remove()
    }
    return (
        <>
        <Container>

        <TextField
                label="Brand"
                name="brand"
                value={url}
                size="medium"
                onChange={handleChange}
                fullWidth
                />
        <Button onClick={submitEve} > Submit</Button>
                </Container>
                </>
    )
}